import React from 'react'

const FeedbackSection = () => {
    return (
        <section className="action-sec dg" style={{ gridTemplateColumns: "auto 16rem", columnGap: "10rem" }}>
            <h4 className="fs2rem fw500 mb2rem c15" style={{ lineHeight: "3.033rem", maxWidth: "42rem" }}>
                We genuinely welcome your feedback – we want to hear from you!
            </h4>
            <div
                className="tac bg1 cp"
                style={{ borderRadius: "1.25rem" }}
                onClick={() => window.open('https://koalendar.com/e/meet-with-mark-bernstein-koaSc6kO?embed=true', '_blank')}
            >
                <img src={require('../../../images/landingpage/schedule.png')} alt='img' style={{ margin: "3rem 1rem 1rem", maxWidth: "7rem" }} />
                <div className="bg4 fw700 cp" style={{ borderRadius: "0 0 1.25rem 1.25rem", fontSize: "1.375rem", padding: "1rem" }}>
                    <div className="df c1 jcsb fs1rem"> Book a Call  <img src={require('../../../images/landingpage/arrow-right.svg')} alt='arrow-right' /></div>
                    <p className="fw400 c1 tal" style={{ lineHeight: "2rem", fontSize: "0.8rem" }}>No recruitment agencies etc</p>
                </div>
            </div>
        </section>
    )
}

export default FeedbackSection